import {roles} from "../../../../../resources/js/plugins/utils";

const packageId = 'user-tracking'
import {hasPermissionByRouteName} from "../../../../../resources/js/router/permissions";

export const navItems = [
  hasPermissionByRouteName(`admin.user-tracking.index`) ? {
    icon: 'mdi-account-supervisor',
    title: 'Captación',
    roles: [roles.ADMIN, roles.USER_TRACKING, roles.MANAGER],
    posRoles: [roles.ADMIN],
    to: {name: "admin.user-tracking.index"},
  } : null,
].filter(Boolean)
